import {Component, OnDestroy, OnInit} from '@angular/core';
// import {Subscription} from 'rxjs/index';
// import { Component, OnInit } from '@angular/core';
// import {ToastService} from '@shared/services/toast.service';
import {ToastService} from '../../services/toast.service';
import {Subscription} from 'rxjs';
import {IToastMessage, ToastType} from '../../models/IToastMessage';
// import {IToastMessage, ToastType} from '@shared/models/IToastMessage';

@Component({
  selector: 'app-toaster',
  templateUrl: './app-toaster.component.html',
  styleUrls: ['./app-toaster.component.scss']
})
export class AppToasterComponent implements OnInit, OnDestroy {

  private _toastSubscription: Subscription;
  private _localToastQueue: IToastMessage[] = [];

  constructor(private _toastService: ToastService) { }

  ngOnInit() {
    this._toastSubscription = this._toastService.toastQueue$.subscribe((toastMsg: IToastMessage) => {
      if (toastMsg && toastMsg.style !== ToastType.BLANK) {
        this._localToastQueue = [toastMsg, ...this._localToastQueue];
        this._toastService.purgeToast();
      }
    });
  }

  ngOnDestroy(): void {
    if (this._toastSubscription) {
      this._toastSubscription.unsubscribe();
    }
  }

  get availableToasts(): IToastMessage[] {
    // console.log('Fetching available toast: ' + this._localToastQueue.length);
    return this._localToastQueue;
  }

  trackToasts(index, toast) {
    return toast ? toast.id : undefined;

  }

  expireToast(idToExpire: number) {
    // console.log('Expiring toast: ' + idToExpire);
    this._localToastQueue = this._localToastQueue.filter((toast: IToastMessage) => {
      return toast.id !== idToExpire;
    });
    // this._toastService.purgeToast();

  }

}
